globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.TableRowsSelectable = (function() {

  function TableRowsSelectable($table) {
    this.$table             = $table;
    this.$selectAllCheckbox = this.$table.find(".rows-select-all");
    this.$actionButtons     = this.$table.find(".rows-action-buttons");
    this.$exportExcelButton = this.$table.closest(".content").find(".btn-export-excel");
    this.$rowsCheckboxes    = this.$table.find(".rows-checkbox-item");

    this.init();
  }

  TableRowsSelectable.init = function($html){
    $html.find('table.table-rows-selectable').each(function(){
      new TableRowsSelectable($(this));
    })
  }

  TableRowsSelectable.prototype = {
    init: function() {
      var _this = this;

      this._refreshActionButtonsState();

      _this.$selectAllCheckbox.on('change', function() {
        _this._refreshRowsState();
        _this._refreshActionButtonsState();
        _this._refreshExportExcelButtonState();
      });

      _this.$rowsCheckboxes.on('change', function() {
        _this._refreshActionButtonsState();
        _this._refreshExportExcelButtonState();
        if(!_this._hasSelectedRows()) {
          _this.$selectAllCheckbox.prop('checked', false).uniform();
        }
      });
    },
    _selectAllCheckboxIsChecked: function(){
      return this.$selectAllCheckbox.is(':checked');
    },
    _hasSelectedRows: function(){
      return this.$rowsCheckboxes.filter(function() { if($(this).is(':checked')) return $(this) }).length > 0;
    },
    _refreshActionButtonsState: function() {
      this.$actionButtons.prop("disabled", !this._hasSelectedRows());
    },
    _refreshExportExcelButtonState: function() {
      this.$exportExcelButton.toggleClass("disabled", this._hasSelectedRows());
    },
    _refreshRowsState: function() {
      this.$rowsCheckboxes.prop('checked', this._selectAllCheckboxIsChecked()).trigger('change').uniform();
    }
  }

  return TableRowsSelectable;

})();
